<template>

    <XModal ref="XModal" :show-overlay="true" @show="onShow">

        <template #header>{{ header }}</template>

        <template #default>

            <div class="mt-3 mb-3" v-html="text"></div>
            <InputText ref="InputText" v-model="value" autofocus class="w-full" @keyup.enter="okBtnClick"/>

        </template>

        <template #footer>

            <Button :icon="okBtnIcon" :label="okBtnLabel" class="p-button-outlined p-button-success"
                    @click="okBtnClick"/>
            <Button class="p-button-outlined" icon="pi pi-times" label="отменить" @click="hide"/>

        </template>

    </XModal>


</template>

<script>


import XModal from "./XModal";

export default {
    name: "ModalInputText",
    components: {XModal},
    emits: ['okBtnClicked'],
    data() {
        return {
            text: '',
            header: '',
            okBtnLabel: 'Ок',
            okBtnIcon: 'Ок',
            value: '',
        }
    },
    methods: {

        okBtnClick() {
            this.$emit('okBtnClicked', this.value);
            this.hide();
        },

        async onShow() {
            this.$refs.InputText.$el.focus();
        },

        async show($defValue, $text, $header, $okBtnLabel = 'Ок', $okBtnIcon = '') {
            this.value = $defValue;
            this.text = $text;
            this.header = $header;
            this.okBtnLabel = $okBtnLabel;
            this.okBtnIcon = $okBtnIcon;
            this.$refs.XModal.show();
        },
        hide() {
            this.$refs.XModal.hide();
        },

    }
}
</script>

<style scoped>

</style>